module.exports = __webpack_public_path__ + "static/img/icon-male.6d73353b.png";